import { backgroundOrange, orange } from '@/theme/colors'
import styled from 'styled-components'

export const ProfileWrapper = styled.div`
	background-color: ${backgroundOrange};
	flex: 1;
	overflow-y: auto;
	width: 100%;
`

export const ProfileContainer = styled.div`
	padding: 2rem 1.5rem;
	max-width: 800px;
	margin: 0 auto;

	@media (max-width: 600px) {
		padding: 1rem 0.875rem;
	}
`

export const ProfileHeader = styled.div`
	margin-bottom: 3rem;
	text-align: center;

	@media (max-width: 600px) {
		margin-bottom: 1.5rem;
	}
`

export const ProfileTitle = styled.h1`
	margin: 0;
	font-size: 2rem;
	font-weight: 700;
	color: #2c3e50;
	text-align: center;

	@media (max-width: 600px) {
		font-size: 1.5rem;
	}
`

export const ProfileContent = styled.div`
	background: white;
	border-radius: 12px;
	padding: 3rem 2rem;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;

	@media (max-width: 600px) {
		padding: 1.5rem 1rem;
		gap: 1.25rem;
	}
`

export const ProfileAvatar = styled.div`
	width: 150px;
	height: 150px;
	border-radius: 50%;
	background: #f3f4f6;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #6c757d;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	@media (max-width: 600px) {
		width: 110px;
		height: 110px;
	}
`

export const ProfileInfo = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
	text-align: center;
`

export const ProfileName = styled.h2`
	margin: 0;
	font-size: 1.5rem;
	font-weight: 600;
	color: #2c3e50;
`

export const ProfileEmail = styled.div`
	font-size: 1rem;
	color: #6c757d;
`

export const ProfileActions = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
	justify-content: center;
`

export const EditButton = styled.button`
	background: white;
	color: ${orange};
	border: 1px solid ${orange};
	padding: 0.75rem 1.5rem;
	border-radius: 8px;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: ${orange};
		color: white;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	&:active {
		opacity: 0.85;
		transform: translateY(0);
	}
`

export const LoadingState = styled.div`
	padding: 4rem 2rem;
	text-align: center;
	color: #6c757d;
`

export const ErrorState = styled.div`
	padding: 4rem 2rem;
	text-align: center;
	color: #dc3545;
`

export const ModalMessage = styled.div`
	padding: 1.5rem;
	text-align: center;
	color: #6c757d;
	font-size: 1rem;
`

